/**
 * Reference data from the WeApp/IIoT platform, served read-only by the API
 * through its `PLATFORM_READ_URL` pool.
 *
 * Thin by design: one function per endpoint, no caching. The pickers that use
 * these are opened, read and closed, and a stale variable list is worse than a
 * second request — `lastValue` is exactly the field an author checks to decide
 * whether a variable is still live.
 */
import { apiFetch } from './client.js'
import type { Asset, Project, Variable, VariableQuery } from '../types/platform.types.js'

export function fetchProjects(signal?: AbortSignal): Promise<Project[]> {
  return apiFetch<Project[]>('/projects', { signal })
}

export function fetchAssets(projectId: number, signal?: AbortSignal): Promise<Asset[]> {
  return apiFetch<Asset[]>(`/projects/${projectId}/assets`, { signal })
}

/**
 * `projectId` is required — the API answers 400 without it, because an
 * unscoped variable search would scan every plant in the platform.
 */
export function fetchVariables(query: VariableQuery, signal?: AbortSignal): Promise<Variable[]> {
  return apiFetch<Variable[]>('/variables', {
    query: {
      projectId: query.projectId,
      assetId: query.assetId,
      q: query.q,
      limit: query.limit,
    },
    signal,
  })
}

export function fetchVariable(id: number, signal?: AbortSignal): Promise<Variable> {
  return apiFetch<Variable>(`/variables/${id}`, { signal })
}
